export const FONT_SIZES = [
    { value: "16px", font: 16 },
    { value: "18px", font: 18 },
    { value: "20px", font: 20 },
    { value: "22px", font: 22 },
    { value: "24px", font: 24 },
    { value: "26px", font: 26 },
];

export const MAIN_STYLES = {
    dark: {
        bg: "black",
        color: "whiteAlpha.900",
    },
    light: {
        bg: "white",
        color: "gray.900",
    },
};